import clsx from 'clsx'
import Head from 'next/head'
import { useState } from 'react'

import { Button } from '@wartek-id/button'
import {
  Sheet,
  SheetCloseButton,
  SheetContent,
  SheetOverlay,
} from '@wartek-id/sheet'
import { Text } from '@wartek-id/text'

import type { TAPIGetProfilePPGDaljabResponse } from 'typings/ppg-daljab'

const Confirmation = ({
  onConfirm,
  data,
}: {
  onConfirm?: () => void
  data: TAPIGetProfilePPGDaljabResponse
}) => {
  const [isSheetOpen, setIsSheetOpen] = useState(false)

  const trimText = (text: string) => (text || '').trim() || '-'

  const {
    nama,
    nuptk,
    satuan_pendidikan,
    jenjang,
    bidang_studi,
    npsn,
    kategori_peserta,
  } = data

  const mappingValue = [
    { label: 'Nama', value: trimText(nama) },
    { label: 'NUPTK', value: trimText(nuptk) },
    { label: 'NPSN', value: trimText(npsn) },
    { label: 'Satuan Pendidikan', value: trimText(satuan_pendidikan) },
    { label: 'Jenjang', value: trimText(jenjang) },
    { label: 'Kategori Peserta', value: trimText(kategori_peserta) },
    { label: 'Bidang Studi', value: trimText(bidang_studi) },
  ]

  return (
    <>
      <div className="p-4" data-testid="ppg-daljab-confirmation">
        <Head>
          <title>Sertifikasi Pendidik | Confirmation</title>
        </Head>
        <div className="bg-white p-2 rounded-md">
          <Text
            className="mb-2"
            variant="heading-sm"
            data-testid="confirmation-welcome"
          >
            Selamat datang di Sertifikasi Pendidik
          </Text>
          <Text variant="body" className="mb-6">
            Program Pendidikan Profesi Guru ini untuk guru dalam jabatan
            mendapat sertifikat pendidik.
            <br />
            <br />
            Pastikan data diri Anda sesuai. Jika tidak, klik tombol
            <b> Data tidak sesuai</b>.
          </Text>

          {mappingValue.map(({ label, value }, idx) => {
            const testName = label.toLowerCase().replace(' ', '-')

            return (
              <div
                className={clsx(
                  idx !== mappingValue.length - 1 &&
                    'border-b border-gray-20 pb-4 mb-4'
                )}
                key={label}
              >
                <Text variant="body" className="mb-1">
                  {label}:{' '}
                  <b data-testid={`ppg-daljab-confirmation-${testName}`}>
                    {value}
                  </b>
                </Text>
              </div>
            )
          })}
        </div>
        <Button className="mt-6" fullWidth size="lg" onClick={onConfirm}>
          Ya, data sesuai
        </Button>
        <Button
          className="mt-3"
          fullWidth
          color="white"
          size="lg"
          data-testid="ppg-daljab-confirmation-sheet-button"
          onClick={() => setIsSheetOpen(true)}
        >
          Data tidak sesuai
        </Button>
      </div>
      <Sheet isOpen={isSheetOpen} onClose={() => setIsSheetOpen(false)}>
        <SheetOverlay />
        <SheetContent className="max-w-xl m-auto">
          <SheetCloseButton onClick={() => setIsSheetOpen(false)} />
          <div className="px-4 pt-2 pb-4">
            <Text
              variant="heading-lg"
              className="mt-8 mb-2"
              data-testid="ppg-daljab-confirmation-sheet"
            >
              Data tidak sesuai
            </Text>
            <Text>Anda bisa lakukan:</Text>
            <ol className="list-decimal pl-5 pr-4">
              <li>
                <Text variant="body">
                  Ajukan perbaikan data ke operator DAPODIK.
                </Text>
              </li>
              <li>
                <Text variant="body">
                  Pastikan data sesuai sebelum mengunduh sertifikat kelulusan,
                  sehingga data di sertifikat Anda akurat.
                </Text>
              </li>
              <li>
                <Text variant="body">
                  Wajib melanjutkan ke tahap berikutnya sambil menunggu
                  perbaikan data.
                </Text>
              </li>
            </ol>
          </div>
        </SheetContent>
      </Sheet>
    </>
  )
}

export default Confirmation
